module.exports = __webpack_public_path__ + "7763f355bdf9547d74bcf9587fe19364.svg";